import { useLocalSearchParams } from 'expo-router';

import { TenantEventsScreen } from '@/components/events/tenant-events-screen';

export default function MemberTenantEventsRoute() {
  const { tenant: tenantSlug } = useLocalSearchParams<{ tenant: string }>();

  return (
    <TenantEventsScreen
      eventHref={(_tenant, event) => ({
        pathname: '/app/events/[id]',
        params: { id: event.id },
      })}
      tenantSlug={tenantSlug}
    />
  );
}
